<template>
  <div class="light_box_video">
    <a
      id="show"
      v-on:click="show"
      class="w-full"
      type="submit"
      style="width: 100%"
      >{{ $root.h_body_buton_q.q_button }}</a
    >
    <div class="box-position text-center">
      <div
        class="lightbox fixed pin z-50 flex justify-center items-center"
        v-if="visible"
      >
        <div
          class="fixed pin-r pin-t text-white cursor-pointer text-4xl p-1 mr-2"
          @click.stop="hide"
        >
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="times"
            class="svg-inline--fa fa-times fa-w-11"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 352 512"
          >
            <path
              fill="currentColor"
              d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
            />
          </svg>
        </div>

        <div class="flex">
          <div class="row_light">
            <div
              class="lightbox-image col-sm-9 col-sm-3 column_light"
              @click.stop
            >
              <div>
                <iframe
                  :src="currentFile"
                  allow="autoplay 'src'"
                  frameborder="0"
                  allowfullscreen
                ></iframe>
                <!--next button  -->
                <!-- <div v-if="nextButton" class="next_button-pre">
                  <button type="submit" v-on:click="goNext()">
                    <i class="fa fa-arrow-right" aria-hidden="true" style="margin-left:-5px;"></i>
                    পরবর্তী মডিউল
                  </button>
                </div> -->
              </div>
            </div>
            <div
              class="light_text col-sm-3 column_light column_light_1"
              @click.stop
            >
              <ul>
                <li v-for="mod in Course.course_modules" :key="mod.id">
                  <dot
                    v-on:click="toggleSelection(mod.id, mod.file_url)"
                    v-bind:class="{ color_active: mod.id == currentSelection }"
                  />
                  <a
                    v-on:click="toggleSelection(mod.id, mod.file_url)"
                    v-bind:class="{ color_active: mod.id == currentSelection }"
                  >
                    {{ mod.title }}
                    <span>
                      <i
                        class="fa fa-chevron-down slide_icon"
                        aria-hidden="true"
                      ></i>
                    </span>
                  </a>
                  <ul
                    v-if="
                      mod.sessions &&
                      mod.sessions.length > 0 &&
                      currentSelection == mod.id
                    "
                    style="overflow-y: hidden"
                  >
                    <li
                      style="
                        padding: 5px 5px;
                        font-size: 12px;
                        display: flex;
                        line-height: 1.4;
                        padding-top: 10px;
                      "
                      v-for="(session_v, s_index) in mod.sessions"
                      :key="s_index"
                      :value="session_v.id"
                      class="session_text"
                    >
                      <i
                        class="fa fa-angle-right"
                        aria-hidden="true"
                        style="padding: 2px 4px"
                      ></i>
                      {{ session_v.title }}
                    </li>
                  </ul>
                  <hr />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Dot from "../assets/svg/dot";
import swal from "sweetalert";
export default {
  components: {
    dot: Dot,
  },
  props: {},
  data() {
    return {
      nextButton: false,
      nextId: 0,
      nextPath: "",
      visible: false,
      index: this.current,
      Course: [],
      course_modules: [],
      sessions: [],
      currentSelection: -1,
      active_id: 0,
      currentFile: "",
    };
  },

  methods: {
    reloadAPI() {
      var course_id = this.$root.getSelectedCourse();
      // Get Data From Offline
      if (!navigator.onLine) {
        this.isLoading = false;
        if (
          window.localStorage.getItem("get-course-module-" + course_id) != null
        ) {
          console.log("Local Data: get-course-module-" + course_id);
          var localData = JSON.parse(
            window.localStorage.getItem("get-course-module-" + course_id)
          );
          this.Course = localData;

          var additionalInfo =
            "#" + this.Course.course_modules[0].id + "@" + user_profile.token;
          this.currentFile =
            this.Course.course_modules[0].file_url + additionalInfo;
          this.currentSelection = this.Course.course_modules[0].id;

          return;
        }
      }

      var user_profile = JSON.parse(window.localStorage.getItem("profile"));
      var config = {
        headers: {
          "X-localization": this.$root.translate ? "bn" : "en",
          Authorization: "bearer " + user_profile.token,
        },
      };
      axios
        .get(
          this.$root.API_BASE_URL +
            "get-course-module?course_id=" +
            this.$root.getSelectedCourse(),
          config
        )
        .then((response) => {
          if (response.data == []) {
            return;
          }
          // Save Locally
          localStorage.setItem(
            "get-course-module-" + course_id,
            JSON.stringify(response.data.data)
          );

          this.Course = response.data.data;

          var additionalInfo = "#" + response.data.data.course_modules[0].id + "@" + user_profile.token;
          this.currentFile = response.data.data.course_modules[0].file_url + additionalInfo;
          this.currentSelection = response.data.data.course_modules[0].id;

          // Check If Last Course Module Exists
          var lastSelection = localStorage.getItem("_lastModuleSelection");
          var lastFilePath = localStorage.getItem("_lastModuleFilePath");

          if(lastSelection != null && lastFilePath != null){
            lastSelection = parseInt(lastSelection);
            if(lastSelection > -1){
              additionalInfo = "#" + lastSelection + "@" + user_profile.token;
              this.currentFile = lastFilePath + additionalInfo;
              this.currentSelection = lastSelection;
            }
          }

          console.log(this.Course.method);
        });

    },
    progressLooper() {
      var id = this.currentSelection;
      var isNextLocked = true;
      var haveNext = null;

      if (localStorage.getItem("_progress_" + id) != null) {
        var localProgress = JSON.parse(localStorage.getItem("_progress_" + id));
        if (localProgress.complete_percent == 100) {
          isNextLocked = false;

          if (this.Course != null) {
            for (var j = 0; j < this.Course.course_modules.length; j++) {
              if (this.Course.course_modules[j].id == id) {
                haveNext = false;
                this.nextId = 0;
                this.nextPath = "";
              } else {
                if (haveNext == false) {
                  this.nextId = this.Course.course_modules[j].id;
                  this.nextPath = this.Course.course_modules[j].file_url;
                }
                haveNext = true;
              }
            }
          }
        }
      }

      // console.log(
      //   "isNextLocked = " +
      //     isNextLocked +
      //     "; haveNext = " +
      //     haveNext +
      //     "; id = " +
      //     id
      // );
      if (isNextLocked == false && haveNext == true) {
        this.nextButton = true;
      } else {
        this.nextButton = false;
      }

      // Next Button Click Monitor
      if (localStorage.getItem("_nextClicked") != null) {
        if (localStorage.getItem("_nextClicked") == "true") {
          localStorage.removeItem("_nextClicked");
          this.goNext();
        }
      }

      setTimeout(() => {
        this.progressLooper();
      }, 500);
    },
    goNext() {
      if (this.nextId != 0 && this.nextPath != "") {
        this.toggleSelection(this.nextId, this.nextPath);
      }
    },
    toggleSelection(id, file_path) {
      var isLocked = true;
      var courseID = this.$root.getSelectedCourse();
      var user_profile = JSON.parse(window.localStorage.getItem("profile"));
      this.nextButton = false;

      // Get Data From Offline
      if (!navigator.onLine) {
        this.isLoading = false;
        if (window.localStorage.getItem("get-my-course") != null) {
          console.log("Local Data: get-my-course");
          console.log(this.Course);

          var last_progress = 100;
          if (this.Course != null) {
            for (var j = 0; j < this.Course.course_modules.length; j++) {
              if (this.Course.course_modules[j].id == id) {
                if (last_progress == 100) {
                  isLocked = false;
                  break;
                } else {
                  break;
                }
              }
              var cx_id = this.Course.course_modules[j].id;
              if (localStorage.getItem("_progress_" + cx_id) != null) {
                var localProgress = JSON.parse(
                  localStorage.getItem("_progress_" + cx_id)
                );
                last_progress = localProgress.complete_percent;
              } else {
                break;
              }
            }
          }

          // Check Offline Progress
          console.log("isLocked = " + isLocked);

          if (isLocked) {
            swal({
              text: "মডিউলটি লক করা আছে! পূর্বেরটি শেষ করুন।",
              buttons: {
                confirm: { text: "ঠিক আছে" },
              },
            });
          } else {
            this.currentSelection = id;
            var additionalInfo = "#" + id + "@" + user_profile.token;
            this.currentFile = file_path + additionalInfo;
          }

          return;
        }
      }

      var config = {
        headers: {
          "X-localization": this.$root.translate ? "bn" : "en",
          Authorization: "bearer " + user_profile.token,
        },
      };

      if (navigator.onLine) {
        axios
          .get(this.$root.API_BASE_URL + "get-my-course", config)
          .then((response) => {
            console.log(response);
            var last_progress = 100;
            if (response.data.data != null) {
              for (var i = 0; i < response.data.data.length; i++) {
                if (response.data.data[i].course.id == courseID) {
                  for (
                    var j = 0;
                    j < response.data.data[i].course.course_modules.length;
                    j++
                  ) {
                    if (
                      response.data.data[i].course.course_modules[j].id == id
                    ) {
                      if (last_progress == 100) {
                        isLocked = false;
                      } else {
                        break;
                      }
                    }
                    if (
                      response.data.data[i].course.course_modules[j]
                        .module_progress != null
                    ) {
                      last_progress =
                        response.data.data[i].course.course_modules[j]
                          .module_progress.percent_int;
                    } else {
                      break;
                    }
                  }
                }
              }
            }
            // Save Locally
            localStorage.setItem(
              "get-my-course",
              JSON.stringify(response.data.data)
            );
            this.get_my_Course = response.data.data;
            if (isLocked) {
              //alert("This Module is Locked");
              swal({
                text: "মডিউলটি লক করা আছে! পূর্বেরটি শেষ করুন।",
                buttons: {
                  confirm: { text: "ঠিক আছে" },
                },
              });
            } else {
              this.currentSelection = id;
              var additionalInfo = "#" + id + "@" + user_profile.token;
              this.currentFile = file_path + additionalInfo;

              localStorage.setItem("_lastModuleSelection", id);
              localStorage.setItem("_lastModuleFilePath", file_path);
            }
          });
      }
    },

    show() {
      //Override Orientation FOR iphone safary
      switch(window.orientation) {  
      case -90: case 90:
        //alert('landscape');
         // Full screen landscape mobile function
        var angulo = window.orientation || screen.orientation || screen.mozOrientation || screen.msOrientation;
        if ((screen.width > 480 && screen.width < 920) && angulo != 0){
          var elem = document.documentElement;
          if (elem.requestFullscreen) {
            elem.requestFullscreen();
          } else if (elem.mozRequestFullScreen) {
            /* Firefox */
            elem.mozRequestFullScreen();
          } else if (elem.webkitRequestFullscreen) {
            /* Chrome, Safari and Opera */
            elem.webkitRequestFullscreen();
          } else if (elem.msRequestFullscreen) {
            /* IE/Edge */
            elem.msRequestFullscreen();
          } else if (elem.oRequestFullscreen) {
            /* opera */
            elem.oRequestFullscreen();
          } else if (elem.RequestFullscreen) {
            /**/
            elem.RequestFullscreen();
          }
        } else {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.mozCancelFullScreen) {
            /* Firefox */
            document.mozCancelFullScreen();
          } else if (document.webkitExitFullscreen) {
            /* Chrome, Safari and Opera */
            document.webkitExitFullscreen();
          } else if (document.msExitFullscreen) {
            /* IE/Edge */
            document.msExitFullscreen();
          } else if (document.oExitFullscreen) {
            /*opera*/
            document.oExitFullscreen();
          } else if (elem.ExitFullscreen) {
            /**/
            elem.ExitFullscreen();
          }
        }
        break; 
      default:
        if (screen.width < 480){
        swal({
          text:"স্ক্রিন টি ঘুরিয়ে আবার চেষ্টা করুন!",
          buttons: {
            confirm : {text:'ঠিক আছে'},
          },
        });
        }
        break; 
      }
      var user_profile = JSON.parse(window.localStorage.getItem("profile"));

      var config = {
        headers: {
          Authorization: "bearer " + user_profile.token,
        },
      };
      axios
        .post(
          this.$root.API_BASE_URL + "course-enrolled",
          {
            course_id: this.$root.getSelectedCourse(),
          },
          config
        )
        .then((response) => {
          // console.log(response.data);
          if (response.data == []) {
            // Blank
            return;
          }
          this.Course_Enrolled = response.data.data;
          console.log(this.Course_Enrolled);
        });
      this.visible = true;
    },
    hide() {
      this.$root.syncOnline();
      this.visible = false;
      this.index = 0;
      var openReview = false;

      if (localStorage.getItem("_quiz") != null) {
        var quiz_data = JSON.parse(localStorage.getItem("_quiz"));
        var gain_point = quiz_data.gain_point;
        if (gain_point >= 80) {
          openReview = true;
        }
      }

      if (this.$root.getLocalValue("review_down") == null) {
        if (navigator.onLine) {
          this.$root.submittedQuiz(() => {
            this.$router.push("/review");
            //window.location.href = "https://adolescent.nnsop.org/review";
          });
        } else {
          if (openReview) {
            this.$router.push("/review");
            //window.location.href = "https://adolescent.nnsop.org/review";
          }
        }
      }
    },
    hasNext() {
      return this.index + 1 < this.images.length;
    },
    hasPrev() {
      return this.index - 1 >= 0;
    },
    prev() {
      if (this.hasPrev()) {
        this.index -= 1;
      }
    },
    next() {
      if (this.hasNext()) {
        this.index += 1;
      }
    },
    onKeydown(e) {
      if (this.visible) {
        switch (e.key) {
          case "ArrowRight":
            this.next();
            break;
          case "ArrowLeft":
            this.prev();
            break;
          case "ArrowDown":
          case "ArrowUp":
          case " ":
            e.preventDefault();
            break;
          case "Escape":
            this.hide();
            break;
        }
      }
    },
  },
  mounted() {
    this.reloadAPI();
    window.addEventListener("keydown", this.onKeydown);
    //window.addEventListener("orientationchange", this.show);
    setTimeout(() => {
      this.progressLooper();
    }, 5000);
  },
  destroyed() {
    window.removeEventListener("keydown", this.onKeydown);
  },
};
</script>

<style>
[type="button"],
[type="reset"],
[type="submit"],
button {
  -webkit-appearance: none;
  /* display: grid; */
}
/* width */
::-webkit-scrollbar {
  width: 4px;
  height: 10%;
}

.next_button-pre {
  position: absolute;
  z-index: 1013;
  border-radius: 6px;
  opacity: 1;
  color: white;
  padding: 6px 20px;
  margin: 8px 0;
  border: none;
  cursor: pointer;
  font-size: 18px;
  font-weight: 600;
  top: 40%;
  left: 50%;
}
.next_button-pre button {
  width: 100%;
  padding: 12px 15px;
  width: 100%;
  font-size: 14px;
  font-weight: 600;
  font-weight: 600;
  background: #8fc15a no-repeat center;
}
.next_button-pre button:hover {
  background: #005a06;
  opacity: 1;
}
/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px #f1f1f1;
  border-radius: 10px;
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: transparent linear-gradient(267deg, #8fc15a 0%, #005a06 100%) 0%
    0% no-repeat padding-box;
  border-radius: 50px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: transparent linear-gradient(267deg, #8fc15a 10%, #005a06 90%) 0%
    0% no-repeat padding-box;
}
.slide_icon {
  font-size: 12px;
  float: right;
  position: absolute;
  right: 4px;
}
.color_active {
  color: #005a06 !important;
}
.lightbox-image iframe {
  width: 924px;
  height: 440px;
}
.flex {
  padding-top: 0px;
}
.w-full:hover {
  color: #fff;
}
.blue_sub {
  color: #00b0ff;
}
.course_button {
  width: 75%;
  margin-left: 20px;
}
.sub_reg {
  width: 18.33%;
}
.course_button {
  width: 75%;
  margin-left: 20px;
}
/* Create two equal columns that floats next to each other */
.column_light {
  float: left;
  padding: 40px 0px;
  height: 440px; /* Should be removed. Only for demonstration */
  display: flex;
  background-color: #fff;
  opacity: 1;
  overflow-y: scroll;
}

/* Clear floats after the columns */
.row_light:after {
  content: "";
  display: table;
  clear: both;
}
.light_text ul li {
  color: black;
  padding: 5px 10px;
  font-size: 16px;
}
.light_text ul {
  list-style: none;
}
.light_text a {
  color: black;
  padding: 4px 0px 0px 16px;
  font-size: 14px;
  width: 95%;
  display: flex;
}
.fa-times {
  right: 104px;
  position: absolute;
  width: 16px;
  height: 16px;
  color: #000;
  background: #fff;
  z-index: 1001;
  margin-top: 4px;
}
.visible {
  opacity: 1;
}
.blur-next {
  opacity: 1;
  z-index: 10;
}
.left-lightbox {
  position: absolute;
}
.right-lightbox {
  position: absolute;
}
.lightbox {
  background: rgba(0, 0, 0, 0.91);
  padding: 80px 100px;
  z-index: 1001;
}

.lightbox-image {
  justify-content: center;
  text-align: center;
}
.lightbox-image img {
  width: auto;
  height: auto;
  max-width: 90%;
  max-height: calc(90vh - 90px);
  transition: transform 30s linear;
  animation: fadeIn ease 1s;
  -webkit-animation: fadeIn ease 1s;
  -moz-animation: fadeIn ease 1s;
  -o-animation: fadeIn ease 1s;
  -ms-animation: fadeIn ease 1s;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-webkit-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.lightbox {
  text-align: center;
  justify-content: center;
  text-align: left;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 4%;
  left: 0;
  opacity: 1;
}
.lightbox-image iframe {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  max-width: 100%;
  max-height: 120%;
}
@media screen and (max-width: 2800px) {
  .lightbox-image iframe {
    max-width: 100%;
  }
  .lightbox-image iframe {
    width: 940px;
    height: 700px;
  }
  /* Create two equal columns that floats next to each other */
  .column_light {
    float: left;
    padding: 40px 0px;
    height: 700px; /* Should be removed. Only for demonstration */
    display: flex;
    background-color: #fff;
    opacity: 1;
  }
  .flex {
    padding-top: 70px;
  }
  .fa-times {
    right: 104px;
    position: absolute;
    width: 16px;
    height: 16px;
    color: #000;
    z-index: 1001;
    margin-top: 74px;
  }
}
@media screen and (max-width: 1921px) {
  .lightbox-image iframe {
    max-width: 100%;
  }
  .lightbox-image iframe {
    width: 1300px;
    height: 800px;
  }
  /* Create two equal columns that floats next to each other */
  .column_light {
    float: left;
    padding: 40px 0px;
    height: 800px; /* Should be removed. Only for demonstration */
    display: flex;
    background-color: #fff;
    opacity: 1;
  }
  .flex {
    padding-top: 40px;
  }
  .fa-times {
    right: 102px;
    position: absolute;
    width: 16px;
    height: 16px;
    color: #000;
    z-index: 1001;
    margin-top: 45px;
  }
}
@media screen and (max-width: 1601px) {
  .lightbox-image iframe {
    max-width: 100%;
  }
  .lightbox-image iframe {
    width: 1280px;
    height: 640px;
  }
  /* Create two equal columns that floats next to each other */
  .column_light {
    float: left;
    padding: 40px 0px;
    height: 640px; /* Should be removed. Only for demonstration */
    display: flex;
    background-color: #fff;
    opacity: 1;
  }
  .flex {
    padding-top: 35px;
  }
  .fa-times {
    right: 100px;
    position: absolute;
    width: 16px;
    height: 16px;
    color: #000;
    z-index: 1001;
    margin-top: 40px;
  }
  .next_button-pre {
    top: 40%;
    left: 40%;
  }
  .next_button-pre button {
    width: 100%;
    padding: 12px 15px;
    width: 100%;
    font-size: 14px;
    font-weight: 600;
    font-weight: 600;
    background: #8fc15a no-repeat center;
  }
}
@media screen and (max-width: 1480px) {
  .next_button-pre {
    top: 40%;
    left: 40%;
  }
  .next_button-pre button {
    width: 100%;
    padding: 10px 15px;
    width: 100%;
    font-size: 14px;
    font-weight: 600;
    font-weight: 600;
    background: #8fc15a no-repeat center;
  }
}
@media screen and (max-width: 1380px) {
  .next_button-pre {
    top: 40%;
    left: 40%;
  }
  .next_button-pre button {
    width: 100%;
    padding: 8px 15px;
    width: 100%;
    font-size: 14px;
    font-weight: 600;
    font-weight: 600;
    background: #8fc15a no-repeat center;
  }
  .lightbox-image iframe {
    max-width: 100%;
  }
  .lightbox-image iframe {
    width: 980px;
    height: 480px;
  }
  /* Create two equal columns that floats next to each other */
  .column_light {
    float: left;
    padding: 40px 0px;
    height: 480px; /* Should be removed. Only for demonstration */
    display: flex;
    background-color: #fff;
    opacity: 1;
  }
  .flex {
    padding-top: 40px;
  }
  .fa-times {
    right: 104px;
    position: absolute;
    width: 16px;
    height: 16px;
    color: #000;
    z-index: 1001;
    margin-top: 45px;
  }
}
@media screen and (max-width: 1300px) {
  .next_button-pre {
    top: 40%;
    left: 40%;
  }
  .next_button-pre button {
    width: 100%;
    padding: 7px 15px;
    width: 100%;
    font-size: 14px;
    font-weight: 600;
    font-weight: 600;
    background: #8fc15a no-repeat center;
  }
  .lightbox-image iframe {
    max-width: 100%;
  }
  .lightbox-image iframe {
    width: 980px;
    height: 480px;
  }
  /* Create two equal columns that floats next to each other */
  .column_light {
    float: left;
    padding: 40px 0px;
    height: 480px; /* Should be removed. Only for demonstration */
    display: flex;
    background-color: #fff;
    opacity: 1;
  }
  .flex {
    padding-top: 40px;
  }
  .fa-times {
    right: 104px;
    position: absolute;
    width: 16px;
    height: 16px;
    color: #000;
    z-index: 1001;
    margin-top: 45px;
  }
}
@media (max-width: 1600) {
  .lightbox-image img {
    max-width: 90%;
  }
}
@media (max-width: 1024) {
  .next_button-pre {
    top: 40%;
    left: 40%;
  }
}
@media screen and (max-width: 990px) {
  .lightbox {
    background: rgba(0, 0, 0, 0.91);
    padding: 30px 20px 20px 20px;
    overflow-y: scroll;
  }
  .next_button-pre {
    top: 40%;
    left: 40%;
  }
  .next_button-pre button {
    padding: 5px 6px;
    width: 100%;
    font-size: 12px;
    font-weight: 600;
  }
  .lightbox-image iframe body {
    position: relative;
  }
  .lightbox-image iframe {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
    max-width: 100%;
    max-height: 100%;
  }
  .light_text a {
    width: 80%;
  }
  .fa-times {
    right: 25px;
    width: 16px;
    height: 16px;
  }
  .column_light {
    float: left;
    padding: 30px 0px;
    height: 220; /* Should be removed. Only for demonstration */
    display: flex;
    background-color: #fff;
    opacity: 1;
  }
}
@media only screen and (min-width: 813px) and (max-width: 920px) and (orientation: landscape) {
  .fa-times {
    right: 28px;
    margin-top: 35px;
  }
  .next_button-pre {
    top: 35%;
    left: 38%;
  }
  .column_light {
    height: 300px;
    width: 580px;
    box-shadow: inset 2px 2px 0px 0px #0000006e;
    padding: 8px 0px;
  }
  .flex {
    padding-top: 30px;
  }
  .light_text a {
    width: 99%;
    font-size: 12px;
    padding: 6px 0px 0px 12px;
  }
  .slide_icon {
    display: none;
  }
  .box-position {
    display: block;
  }
}
@media only screen and (min-width: 801px) and (max-width: 812px) and (orientation: landscape) {
  .fa-times {
    right: 22px;
    margin-top: 35px;
  }
  .next_button-pre {
    top: 35%;
    left: 38%;
  }
  .next_button-pre button {
    padding: 5px 6px;
    width: 100%;
    font-size: 12px;
    font-weight: 600;
  }
  .column_light {
    height: 280px;
    width: 580px;
    box-shadow: inset 2px 2px 0px 0px #0000006e;
    padding: 8px 0px;
  }
  .flex {
    padding-top: 30px;
  }
  .light_text a {
    width: 99%;
    font-size: 12px;
    padding: 6px 0px 0px 12px;
  }
  .slide_icon {
    display: none;
  }
  .box-position {
    display: block;
  }
}
@media only screen and (min-width: 712px) and (max-width: 800px) and (orientation: landscape) {
  .fa-times {
    right: 22px;
    margin-top: 35px;
  }
  .next_button-pre {
    top: 35%;
    left: 38%;
  }
  .column_light {
    height: 300px;
    width: 580px;
    box-shadow: inset 2px 2px 0px 0px #0000006e;
    padding: 8px 0px;
  }
  .flex {
    padding-top: 30px;
  }
  .light_text a {
    width: 99%;
    font-size: 12px;
    padding: 6px 0px 0px 12px;
  }
  .slide_icon {
    display: none;
  }
  .box-position {
    display: block;
  }
}
@media only screen and (min-width: 576px) and (max-width: 711px) and (orientation: landscape) {
  .fa-times {
    right: 22px;
    margin-top: 35px;
  }
  .next_button-pre {
    top: 35%;
    left: 35%;
  }
  .column_light {
    height: 270px;
    width: 580px;
    box-shadow: inset 2px 2px 0px 0px #0000006e;
    padding: 8px 0px;
  }
  .flex {
    padding-top: 30px;
  }
  .light_text a {
    width: 99%;
    font-size: 12px;
    padding: 6px 0px 0px 12px;
  }
  .slide_icon {
    display: none;
  }
  .box-position {
    display: block;
  }
}

@media only screen and (min-width: 513px) and (max-width: 575px) and (orientation: landscape) {
  .fa-times {
    right: 22px;
    margin-top: 35px;
  }
  .next_button-pre {
    top: 32%;
    left: 34%;
  }
  .column_light {
    height: auto;
    width: 580px;
  }
  .column_light {
    height: auto;
    width: 580px;
    box-shadow: inset 2px 2px 0px 0px #0000006e;
    padding: 8px 0px;
  }
  .lightbox-image iframe {
    width: 89%;
    height: 100%;
  }
  .lightbox-image iframe {
    position: absolute;
    top: 46%;
    left: 45%;
    -webkit-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
    max-width: 100%;
    max-height: 100%;
  }
  .flex {
    padding-top: 30px;
  }
  .light_text a {
    width: 100%;
    font-size: 12px;
    padding: 6px 0px 0px 12px;
  }
  .slide_icon {
    display: none;
  }
  .box-position {
    display: block;
  }
  .lightbox-image iframe {
    max-width: 89%;
    height: 240px;
  }
}
@media only screen and (min-width: 480px) and (max-width: 512px) and (orientation: landscape) {
  .fa-times {
    right: 22px;
    margin-top: 35px;
  }
  .next_button-pre {
    top: 28%;
    left: 27%;
  }
  .column_light {
    height: 230px;
    width: 580px;
  }
  .column_light {
    height: auto;
    width: 580px;
    box-shadow: inset 2px 2px 0px 0px #0000006e;
    padding: 8px 0px;
  }
  .lightbox-image iframe {
    width: 75%;
    height: 100%;
  }
  .lightbox-image iframe {
    position: absolute;
    top: 43%;
    left: 38%;
    -webkit-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
    max-width: 100%;
    max-height: 100%;
  }
  .flex {
    padding-top: 30px;
  }
  .light_text a {
    width: 100%;
    font-size: 12px;
    padding: 6px 0px 0px 12px;
  }
  .slide_icon {
    display: none;
  }
  .box-position {
    display: block;
  }
  .lightbox-image iframe {
    max-width: 89%;
    height: 230px;
  }
}
@media (max-width: 767px) {
  .column_light {
    height: 270px;
    width: 580px;
  }
  .flex {
    padding-top: 30px;
  }
}
@media only screen and (max-width: 683px) {
  .lightbox-image img {
    max-width: 90%;
  }
  .light_box_video a {
    font-size: 16px;
  }
  .lightbox-image img {
    position: absolute;
    top: 52%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    max-width: 80%;
    max-height: 90%;
  }
  .right-lightbox {
    text-align: right;
    right: -5px;
    position: absolute;
    top: 50%;
  }
  .left-lightbox {
    text-align: right;
    left: -5px;
    position: absolute;
    top: 50%;
  }
}
@media (max-width: 583px) {
  .light_text ul {
    list-style: none;
    overflow-y: scroll;
  }
  .row_light {
    overflow-y: scroll;
  }

  .flex {
    padding-top: 30px;
  }
  .fa-times {
    right: 22px;
    position: absolute;
    width: 20px;
    height: 20px;
    color: #000;
    z-index: 1001;
    margin-top: 35px;
  }
}
@media (max-width: 479px) and (orientation: portrait) {
  .box-position {
    display: none;
  }
}
</style>
